import {
  is_development,
  log,
  is_mobile,
  is_authenticated,
  get_config,
  get_availability,
  format_price,
  get_site_name,
} from "./commons";

/**
 * Checks if an element's text content is truncated (ellipsis visible)
 * Works for both single-line (text-truncate) and multi-line (line-clamp) truncation
 * @param {HTMLElement} element - The DOM element to check
 * @returns {boolean} - True if text is truncated, false otherwise
 */
function is_text_truncated(element) {
  if (!element) return false;
  const is_horizontally_truncated = element.scrollWidth > element.clientWidth;
  const is_vertically_truncated = element.scrollHeight > element.clientHeight;
  return is_horizontally_truncated || is_vertically_truncated;
}

/**
 * Retrieves a nested property value from an object using dot notation (or custom separator).
 *
 * @param {Object} obj - The object to extract the value from
 * @param {string} field - The path to the property (e.g., "user.address.city")
 * @param {string} [separator="."] - The separator used in the field path
 * @returns {*} The value at the specified path, or undefined if not found
 *
 * @example
 * const data = { user: { name: "John", address: { city: "NYC" } } };
 *
 * get_object_field(data, "user.name");           // "John"
 * get_object_field(data, "user.address.city");   // "NYC"
 * get_object_field(data, "user.missing");        // undefined
 * get_object_field(data, "user/name", "/");      // "John" (custom separator)
 */
const get_object_field = (obj, field, separator = ".") => {
  if (!obj || !field) {
    return;
  }
  if (!field.includes(separator)) {
    return obj[field];
  }
  const [current_level, ...levels] = field.split(separator);
  return get_object_field(
    obj[current_level],
    levels.join(separator),
    separator,
  );
};

const scroll_window = (position = {}) => {
  try {
    if (!window) {
      return;
    }

    const scroll = window.scroll || window.scrollTo;
    if (!scroll) {
      return;
    }

    const use_object = Object.keys(position).some((key) =>
      ["top", "left", "behavior"].includes(key),
    );
    if (use_object) {
      scroll(position);
      return;
    }
    const { x = 0, y = 0 } = position;
    scroll(x, y);
  } catch (e) {
    log("scroll_window", e);
  }
};

export default {
  methods: {
    is_development: is_development,
    log: log,
    is_mobile: is_mobile,
    is_authenticated: is_authenticated,
    get_config: get_config,
    get_availability: get_availability,
    format_price: format_price,
    get_site_name: get_site_name,
    is_text_truncated: is_text_truncated,
    get_object_field,
    scroll_window,
    scroll_top() {
      scroll_window({ top: 0, behavior: "smooth" });
    },
  },
};
